/* Native-theme additions: reliable original films, preview routing and scoped safety UI. */
(() => {
  'use strict';
  const motion=matchMedia('(prefers-reduced-motion: reduce)');
  function film(video) {
    if(video.dataset.nativeFilmReady)return;
    video.dataset.nativeFilmReady='true';
    video.muted=true;video.defaultMuted=true;video.playsInline=true;video.loop=true;
    video.setAttribute('muted','');video.setAttribute('playsinline','');
    const surface=video.closest('.theian-hero-wrap,.tc-hero,.backgroundvideo,.video-background');
    let pausedByUser=false;
    let button;
    if(surface) {
      if(getComputedStyle(surface).position==='static')surface.style.position='relative';
      button=document.createElement('button');button.type='button';button.className='th-native-film-control';surface.append(button);
      button.addEventListener('click',()=>{pausedByUser=!video.paused;if(pausedByUser)video.pause();else video.play().catch(sync);});
    }
    function sync() {if(button){button.textContent=video.paused?'Play film ▷':'Pause film Ⅱ';button.setAttribute('aria-label',video.paused?'Play background film':'Pause background film');}}
    function play(){if(!pausedByUser&&!motion.matches&&!document.hidden)video.play().catch(sync);else if(motion.matches)video.pause();sync();}
    video.addEventListener('playing',sync);video.addEventListener('pause',sync);video.addEventListener('canplay',play);
    document.addEventListener('visibilitychange',play);motion.addEventListener('change',play);
    if(motion.matches){video.removeAttribute('autoplay');video.pause();}else video.setAttribute('autoplay','');
    play();sync();
  }
  function nativeLinks(root=document) {
    root.querySelectorAll('a[href]').forEach(a=>{
      const raw=a.getAttribute('href');if(!raw||/^(#|mailto:|tel:)/.test(raw))return;
      try{
        const u=new URL(raw,location.href);if(u.origin!==location.origin)return;
        if(!/^\/(?:$|collections(?:\/|$)|products(?:\/|$)|pages(?:\/|$)|blogs(?:\/|$)|policies(?:\/|$)|search(?:\/|$))/.test(u.pathname))return;
        if(['theian','theian-owned'].includes(u.searchParams.get('view')))u.searchParams.delete('view');
        if(!/^\/(cart|checkout)(\/|$)/.test(u.pathname))u.searchParams.set('preview_theme_id',document.body.dataset.themeId);
        a.href=u.href;
      }catch(_){}
    });
  }
  function campaignFilm(surface) {
    if(surface.dataset.ready)return;
    const video=surface.querySelector('video'),button=surface.querySelector('[data-film-toggle]');
    if(!video||!button)return;
    surface.dataset.ready='true';button.hidden=false;
    const title=video.getAttribute('aria-label')||'campaign film';
    function sync(){button.textContent=video.paused?'▷ Play film · Sound on':'Ⅱ Pause film';button.setAttribute('aria-label',(video.paused?'Play ':'Pause ')+title);}
    button.addEventListener('click',()=>{if(video.paused){document.querySelectorAll('.th-trust-film').forEach(other=>{if(other!==video)other.pause();});video.muted=false;video.play().catch(sync);}else video.pause();});
    video.addEventListener('play',()=>{document.querySelectorAll('.th-trust-film').forEach(other=>{if(other!==video)other.pause();});sync();});
    video.addEventListener('pause',sync);video.addEventListener('ended',sync);sync();
  }
  function init(root=document){root.querySelectorAll('video[autoplay],.theian-hero-video,.tc-hero video').forEach(film);root.querySelectorAll('[data-campaign-film]').forEach(campaignFilm);nativeLinks(root);}
  document.addEventListener('shopify:section:load',e=>init(e.target));
  // Retain the shared preview in native navigation and AJAX-rendered product grids.
  document.addEventListener('click',e=>{const link=e.target.closest('a[href]');if(link)nativeLinks(link.parentElement);},true);
  init();
})();
